export default "__VITE_ASSET__DTcGVete__"